//@flow

import {catchError, map, switchMap} from 'rxjs/operators';
import {ofType} from 'redux-observable';
import {of} from 'rxjs';

import {ActionCreator, createReducer} from '../../store/utils';

import {getPageLayoutApi} from './api';

import type {HomePageLayout, PageLayoutType} from '../../entities';
import type {ActionsObservable} from 'redux-observable';

type Layouts = {
  HOME_PAGE?: HomePageLayout,
};

export type PageLayoutState = {
  layouts: Layouts,
  loading?: boolean,
};

export type PageLayoutAction = {
  layouts?: Layouts,
  layoutType?: PageLayoutType,
};

export class FetchPageLayout extends ActionCreator<PageLayoutAction> {}
export class FetchPageLayoutSuccess extends ActionCreator<PageLayoutAction> {}
export class FetchPageLayoutError extends ActionCreator<PageLayoutAction> {}

export class UpdatePageLayout extends ActionCreator<PageLayoutAction> {}

export const actions = {
  fetchPageLayout: (layoutType: PageLayoutType) =>
    new FetchPageLayout({
      layoutType,
    }),
  updatePageLayout: (layouts: Layouts) => new UpdatePageLayout({layouts}),
};

export const initialState: PageLayoutState = {
  layouts: {},
  loading: false,
};

export default createReducer(initialState, {
  [FetchPageLayout.type]: (state: PageLayoutState): PageLayoutState => ({
    ...state,
    loading: true,
  }),
  [FetchPageLayoutSuccess.type]: (
    state: PageLayoutState,
    {layouts}: PageLayoutAction
  ): PageLayoutState => {
    if (!layouts) return state;
    const homePageLayout = {...layouts.HOME_PAGE};

    const newLayouts = {...state.layouts, ...layouts};

    if (homePageLayout) {
      const layout = homePageLayout.layout || [];
      /*       DYNAMIC_HOME_PAGE_SECTIONS_NAME_LIST.forEach(sectionName => {
        const exist = layout.some(layoutSection => {
          return layoutSection.pageSectionType === sectionName;
        });

        if (!exist) {
          const defaultSection = DEFAULT_HOME_PAGE_LAYOUT.layout.find(
            section => section.pageSectionType === sectionName
          );
          if (defaultSection) {
            layout.push({
              ...defaultSection,
              enabled: true,
            });
          }
        }
      }); */

      //$FlowFixMe
      newLayouts.HOME_PAGE = {
        ...homePageLayout,
        layout: layout,
      };
    }

    return {
      ...state,
      loading: false,
      layouts: newLayouts,
    };
  },
  [FetchPageLayoutError.type]: (state: PageLayoutState): PageLayoutState => ({
    ...state,
    loading: false,
  }),
  [UpdatePageLayout.type]: (
    state: PageLayoutState,
    {layouts}: PageLayoutAction
  ): PageLayoutState => ({
    ...state,
    layouts: {
      ...state.layouts,
      ...layouts,
    },
  }),
});

export function fetchPageLayoutEpic(action$: ActionsObservable) {
  return action$.pipe(
    ofType(FetchPageLayout.type),
    switchMap(({layoutType}) => {
      return getPageLayoutApi({page_layout_type: layoutType}).pipe(
        map(response => {
          return new FetchPageLayoutSuccess({
            layouts: {
              [layoutType]: response,
            },
          });
        }),
        catchError(() => of(new FetchPageLayoutError()))
      );
    })
  );
}
